import { Auth } from '@aws-amplify/auth'
import { HttpError, sendHttpRequest } from './httpClient.js'

const JSON_OBJECT_DELIMITER = 'jsonobjectdelimiter'

export const requestChatLambda = async ({
  messages,
  aiVersion,
  tools,
  streamText = false,
  returnReader = false,
  signal
}) => {
  if (!messages || messages.length === 0) {
    throw new Error('Cannot make AI call with empty messages.')
  }

  const LAMBDA_URL = process.env.VUE_APP_CHAT_LAMBDA_URL
  let jwtToken
  try {
    const currentUser = await Auth.currentAuthenticatedUser()
    jwtToken = currentUser.signInUserSession.idToken.jwtToken
  } catch (authError) {
    throw new Error('User authentication failed. Cannot call AI service.')
  }

  const requestBody = {
    aiVersion,
    messages,
    tools,
    streamText
  }

  const requestHeaders = {
    Authorization: `Bearer ${jwtToken}`,
    'Content-Type': 'text/plain;charset=UTF-8'
  }

  try {
    const response = await sendHttpRequest(
      LAMBDA_URL,
      'POST',
      requestHeaders,
      JSON.stringify(requestBody),
      signal
    )

    if (returnReader) {
      if (!response.body) {
        throw new Error('Response body is null, cannot return reader.')
      }
      return response.body.getReader()
    }

    const rawText = await response.text()

    if (streamText) {
      return rawText
    } else {
      if (rawText.trim() === '') {
        return null
      }
      const parts = rawText.split(JSON_OBJECT_DELIMITER).filter(part => part.trim() !== '')
      if (parts.length === 0) {
        return null
      }
      return JSON.parse(parts[0])
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error
    }

    if (error instanceof HttpError) {
      throw new Error(`AI Lambda service call failed: ${error.message}. Server detail: ${error.body || 'N/A'}`)
    }

    throw new Error(`AI Lambda service call failed: ${error.message}`)
  }
}
